import logo from './logo.svg';
import './App.css';
import Home from './components/Home';
import Sidebar from './components/Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useState } from 'react';
import { Toast } from 'bootstrap';
import { ToastContainer } from 'react-toastify';

function App() {

  const [userdata, setUserdata] = useState({
    name: 'Name',
    position: 'Position',
    extension: '12345',
    number: "+966*****",
    fax: "+966*****",
    email: 'Email',
  })
  const imageList = [
    { title: "Riyadh", img: "", addressone: "Al Mousa Complex, Tower 4, Olaya Street. 11393", addresstwo:"Riyadh, KSA",phonenumber: "+966 11 461 0784",subtitle:"UHY Al Mousa Certified Public Accountants & Consultants",siteLink:"https://uhy-sa.com/",siteText:"www.uhy-sa.com" },
    { title: "Khobar", img: "", addressone: "Office No.208, Jarir Building, Prince Turki Bin Abdulaziz Street",addresstwo:"Al Khobar, KSA", phonenumber: "+966 13 884 7772",subtitle:"UHY Al Mousa Certified Public Accountants & Consultants",siteLink:"https://uhy-sa.com/",siteText:"www.uhy-sa.com" }]

  const [addressIndex, setAddressIndex] = useState(0)

  return (
    <div className="container-fluid">
      <div className="row flex-xl-nowrap">
        <div className="col-12 col-md-3 col-xl-3 sidebar">
          <ToastContainer />
          <Sidebar userdata={userdata} setUserdata={setUserdata} imageList={imageList} setAddressInfo={(index) => { setAddressIndex(index) }} />
        </div>

        <div className="col-12 col-md-9 col-xl-9 content-container">
          <Home userdata={userdata} imageList={imageList} activeData={imageList[addressIndex]} />
        </div>
      </div>
    </div>
  );
}

export default App;
